/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import Meta from 'vue-meta'

// Routes
import paths from './paths'

Vue.use(Router)

// Create a new router
const router = new Router({
  mode: 'history',
  // routes: paths.map(path => route(path.path, path.view, path.name)).concat([
  //   { path: '*', redirect: '/' }
  // ]),
  routes: paths,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  },
})

Vue.use(Meta)

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== 'development',
    },
  })
}

router.beforeEach((to, from, next) => {
  console.log('URL guard called...')
  console.log('to: ' + to.fullPath)
  
  if (to.matched.some(record => record.meta.pengajuanExternal)) {
    next()
  }
  
  const loggedIn = localStorage.getItem('user')
  const userData = JSON.parse(loggedIn)
  console.log("userData")
  console.log(userData)
  
  if (loggedIn && to.fullPath === "/verify-file") {
    console.log("verify")
    next()
  }
  if (loggedIn && to.fullPath === "/ganti-password") {
    next()
  }
  if (loggedIn && to.fullPath === "/dokumen-tabs") { 
    next()
  }

  if (!loggedIn && (to.fullPath === "/home-page" || to.fullPath === "/")) {
    console.log("to homepage")
    next()
  }

  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/')
  }

  if (to.matched.some(record => record.meta.loginForm) && loggedIn) {
    next('/profil')
  }

  if (!to.matched.length) {
    next('/404')
  }
  // if (to.matched.length && loggedIn && to.fullPath !== '/403' && userData.menus[0].menuCode && !isPublic) {
  if (to.matched.length && loggedIn && to.fullPath !== '/403' && to.fullPath != '/home' && to.fullPath != '/home-page' && to.fullPath != '/sandbox') {
    //cek last activity idle >= 1 jam, jika iya logout
    console.log('Checking access time...')
    const accessTime = new Date(localStorage.getItem('accessTime'))
    const accessTimePlusHour = accessTime.setHours(accessTime.getHours() + 1)
    if (accessTimePlusHour < Date.now()) {
      console.log('-- access time expired --')
      localStorage.clear()
      location.reload()
    } else {
      console.log('-- update access time --', new Date(accessTimePlusHour))
      localStorage.setItem('accessTime', new Date())
    }

    console.log('Checking privilege menu...')
    // Routes marked allRoles (e.g. /help) are open to every logged-in role
    var isAllow = to.matched.some(record => record.meta.allRoles)
    if (!isAllow) {
      var listmenu = userData.list_menu[localStorage.getItem("currentPeran")]
      listmenu = listmenu.map(item => item.nama.replace(/\s+/g, '').replace(/[^\w\s]/gi, '').toUpperCase()); // Make listmenu clean & uppercased
      isAllow = listmenu.includes(to.name.replace(/\s+/g, '').replace(/[^\w\s]/gi, '').toUpperCase()) // Check if menu is allowed
    }

    console.log('Is menu ' + to.name + ' allowed? '  + isAllow)
    // alert(JSON.stringify(to.path))
    if (!isAllow && !to.matched.some(record => record.meta.loginForm)) {
      console.log('Access rejected!', next())
      next('/403')
    }

    var passStatus = localStorage.getItem("status")
    if (passStatus != "ACTIVE" ) {
      next('/ganti-password')
    }
    next()
  }
  next()
})

export default router
